import React from 'react'


export default function ServiceCard({title,icon , dataaos , delay}) {

  return (
    <>
      <div className="animieService" data-aos = {dataaos} data-aos-delay={delay} data-aos-offset="100" >
      <div className="serviceCard"  >
      <i className={icon}></i>
      <h2>{title}</h2>
      <p>Mauris aliquam, turpis sed mattis placerat, justo risus pellentesque quam, id finibus risus arcu eget neque.</p>
      </div>
      </div>
    </>
  )
}
